var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard workout-by-page"},[_c('tabs'),_c('div',{staticClass:"box-tab-content"},[_c('div',{staticClass:"workout-slider-block"},[_c('workoutsSlider')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }